import { createContext } from 'react';
import { BillingHistoryDataInterpreter } from '../machines/billingHistoryData/types';

import { BillingFiltersInterpreter } from '../machines/billingFilters';
import type { FiltersOptionsInterpreter } from '../machines/filtersOptions';

export const GlobalStateContext = createContext<{
  billingHistoryDataService: BillingHistoryDataInterpreter;
  billingFiltersService: BillingFiltersInterpreter;
  filtersOptionsService: FiltersOptionsInterpreter;
}>({
  billingHistoryDataService: null,
  billingFiltersService: null,
  filtersOptionsService: null,
});
